import React, { useEffect, useState } from "react";

import { showApiError } from "../utils/errorRoutingUtils";
import { useHistory } from "react-router-dom";

import shallow from "zustand/shallow";
import useCurrentAccountStore from "./AccountStore";
import useAccountDefaultStore from "./AccountDefaultsStore";
import useSetAccount from "./useSetAccount";
import { LoanPeriod, PATHS, vendorTypesOBJ } from "../constants/Constants";
import { retrieveFailAlert } from "../utils/alertUtils";
import useRoute from "../hooks/useRoute";
import { useFromUser } from "../stores/LocalStorageHelper";
import Loading from "../components/loadingSpinner/Loading";
import AccountCustomerHeader from "./AccountCustomerHeader";
import AccountAddDetail from "./AccountAddDetail";
import {
	getAccountDetails,
	getAcctDefaults,
	getNewAccount,
	saveAccountTable,
} from "./AccountAPI";
import dayjs from "dayjs";
import { Card, CardHeader, CardTitle, Row } from "reactstrap";
import AccountAddDeferred from "./AccountAddDeferred";
import AccountAddVehicle from "./AccountAddVehicle";
import { FormProvider, useForm } from "react-hook-form";
import { AccountSaveButton } from "./AccountSaveButton";
import { getVendorListByType } from "../api/VendorsAPI";
import { yupResolver } from "@hookform/resolvers";
import * as yup from "yup";
import { calculateFirstDueDate } from "../features/deal/helperFunctions/SaleFunctions";

const AccountModificationPage = (prop) => {
	//	console.log(isModify);
	//console.log(accountID);
	const accountID = prop.location.state?.accountID;
	const today = dayjs().format("YYYY-MM-DD");
	// Grab information from local storage
	const dcLoginID = useFromUser("ID");
	const dealerID = useFromUser("dealerID");
	const locationID = useFromUser("locationID");
	const firstName = useFromUser("firstName");
	const lastName = useFromUser("lastName");
	const [modifyAccount, setModifyAccount] = useState({});
	// Routes
	const history = useHistory();

	const { editAcctDefaults } = useAccountDefaultStore(
		(state) => state,
		shallow
	);
	//const acctID = prop.location.state?.acctID;
	const acctListPage = useRoute(PATHS.ACCT_LIST);
	const setAccount = useSetAccount();

	// Account store
	const acctObj = useCurrentAccountStore((state) => state, shallow);
	const [isLoading, setIsLoading] = useState(true);

	const schema = yup.object().shape({
		acctNumber: yup.string().required().max(50),
		// loanDate: yup.string().required(),
		// amtFinanced: yup.string().required(),
		// apr: yup.string().required(),
		// loanPeriod: yup.string().required(),
		// payoffMethod: yup.string().required(),
		// term: yup.string().required(),
		// daysToPay: yup.string().required(),
	});
	const methods = useForm({
		reValidateMode: "onBlur",
		resolver: yupResolver(schema),
	});

	const getNewData = () => {
		console.log(acctObj);

		Promise.all([
			getAcctDefaults(locationID),
			getNewAccount(),
			getVendorListByType(locationID, vendorTypesOBJ.LENDER.value),
			getAccountDetails(accountID),
		]).then(
			(res) => {
				editAcctDefaults(res[0].data.content);
				setAccount(res[1]);

				let newAccount = { ...res[1].data.content.account };

				newAccount.locationID = locationID;
				newAccount.dealerID = dealerID;
				newAccount.createdBy = lastName + ", " + firstName;
				newAccount.modifiedBy = lastName + ", " + firstName;
				newAccount.modifiedById = dcLoginID;
				newAccount.createdById = dcLoginID;
				newAccount.createdOn = today;
				newAccount.modifiedOn = today;
				newAccount.period = 3;
				newAccount.daysToPay = 30;
				newAccount.firstDueDate = "";
				newAccount.loanDate = today;
				newAccount.type = "Car";
				newAccount.saleType = 0;
				newAccount.apr = 0;
				newAccount.amtFinanced = 0;
				newAccount.term = 36;
				newAccount.payoffMethod = 1;
				newAccount.notes = "";
				newAccount.pickupOnly = false;
				newAccount.isTaxDeferred = false;
				newAccount.totalCost = 0;
				newAccount.status = 0;
				newAccount.subStatus = "Current";
				newAccount.firstDueDate = dayjs().add(30, "days").format("YYYY-MM-DD");
				newAccount.autoMessaging = res[0].data.content.autoMessaging;

				const loanPeriod_ = res[3].data.content.account.period;
				const daysToPay_ = LoanPeriod[loanPeriod_].daysInPeriod;
				const firstDueDate_ = calculateFirstDueDate(daysToPay_, today);
				newAccount.apr = res[3].data.content.account.apr;
				newAccount.term = res[3].data.content.account.term;
				newAccount.amtFinanced = res[3].data.content.account.payoff;
				newAccount.loanDate = today;
				newAccount.firstDueDate = firstDueDate_;
				newAccount.loanPeriod = loanPeriod_;
				newAccount.stockNum = res[3].data.content.account.stockNum;
				newAccount.vin = res[3].data.content.account.vin;
				newAccount.year = res[3].data.content.account.year;
				newAccount.make = res[3].data.content.account.make;
				newAccount.model = res[3].data.content.account.model;
				newAccount.subModel = res[3].data.content.account.subModel;
				newAccount.price = res[3].data.content.account.price;
				newAccount.newUsed = res[3].data.content.account.newUsed;
				newAccount.licensePlate = res[3].data.content.account.LicensePlate;
				newAccount.odometer = res[3].data.content.account.odometer;

				newAccount.mileageOut = res[3].data.content.account.mileageOut;

				newAccount.HasGPS = res[3].data.content.account.HasGPS;
				newAccount.gps_ID = res[3].data.content.account.gps_ID;
				newAccount.gpsType = res[3].data.content.account.gpsType;
				newAccount.gpsCompany = res[3].data.content.account.gpsCompany;
				newAccount.gpsWebsite = res[3].data.content.account.gpsWebsite;
				newAccount.hasGPS2 = res[3].data.content.account.hasGPS2;
				newAccount.gps_ID2 = res[3].data.content.account.gps_ID2;
				newAccount.gpsType2 = res[3].data.content.account.gpsType2;
				newAccount.gpsCompany2 = res[3].data.content.account.gpsCompany2;
				newAccount.gpsWebsite2 = res[3].data.content.account.gpsWebsite2;
				newAccount.dealRecNum = res[3].data.content.account.dealRecNum;
				newAccount.accountNumber =
					"R_" + res[3].data.content.account.accountNumber;
				acctObj.editAccount(newAccount);
				acctObj.editLenders(res[2].data.content);

				acctObj.editBuyerRecNum(res[3].data.content.account.buyerRecNum);
				acctObj.editBuyer(res[3].data.content.buyer);
				acctObj.editBuyerAddress(res[3].data.content.currentAddress);
				acctObj.editBuyerMailAddress(res[3].data.content.mailingAddress);
				acctObj.editBuyerInsuranceInfo(res[3].data.content.insuranceInfo);

				acctObj.editCoBuyerRecNum(res[3].data.content.account.coBuyerRecNum);
				acctObj.editCoBuyer(res[3].data.content.coBuyer);
				acctObj.editCoBuyerAddress(res[3].data.content.coBuyerAddress);
				acctObj.editCoBuyerMailAddress(res[3].data.content.coBuyerMailAddress);

				setModifyAccount({
					...res[3].data.content.account,
					status: 1,
					subStatus: "Paid Off",
					closeDate: today,
				});
				setIsLoading(false);
			},
			(err) => {
				if (!err.isGeneralError) {
					showApiError(err, retrieveFailAlert);
					history.push(acctListPage);
				}
			}
		);
	};

	useEffect(() => {
		console.log(isLoading);
		//		console.log(accountID);
		if (isLoading) {
			if (accountID) {
				getNewData();
			}
		}

		return () => {
			acctObj.reset();
		};
	}, []);
	return (
		<Card className="px-0 content">
			<CardHeader className="text-center" tag="h3">
				Loan Modification
			</CardHeader>
			<div>
				<div className="col-md-12 px-0 content">
					{(isLoading && <Loading />) || (
						<FormProvider {...methods}>
							<Row className="">
								<div className="col-md-4">
									<AccountCustomerHeader />

									{/* <AccountInventoryHeader /> */}
									<AccountAddVehicle />
								</div>
								<div className="col-md-4">
									<AccountAddDetail />
								</div>
								<div className="col-md-4">
									<AccountAddDeferred />
								</div>
							</Row>
							<AccountSaveButton modifyAccount={modifyAccount} />
						</FormProvider>
					)}
				</div>
			</div>
		</Card>
	);
};

export default AccountModificationPage;
